import React from 'react';
import noop from 'lodash/noop';
import ClickAwayListener from '../ClickAwayListener';

export const ModalContainer = ({
  onClose = noop,
  children,
  contentDirection,
  modalClassName: customModalClassName,
  opacity
}) => {
  const getModalContentClassName = (direction) => {
    const classNames = [
      'absolute align-bottom',
      'bg-white text-left overflow-hidden shadow-xl',
      'transform transition-all sm:align-middle',
      'overflow-y-auto',
    ];

    if (direction === 'right') {
      classNames.push('top-0 bottom-0 right-0 sm:max-w-screen-sm sm:w-full');
    }
    if (direction === 'full-width') {
      classNames.push('top-12 bottom-0 right-0 w-full rounded-lg max-h-95');
    }
    return classNames.join(' ');
  };

  const getModalClassName = (className, direction) => {
    const classNames = ['fixed z-50 inset-0', className];

    if (direction !== 'full-width') {
      classNames.push('overflow-y-auto');
    }
    return classNames.join(' ');
  };

  const modalContentClassName = getModalContentClassName(contentDirection);
  const modalClassName = getModalClassName(customModalClassName, contentDirection);

  return (
    <div className={modalClassName}>
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity">
          <div className={`absolute inset-0 bg-black ${opacity ? `opacity-${opacity}` : "opacity-75"}`}></div>
        </div>
        <ClickAwayListener onClickAway={onClose}>
          <div
            className={modalContentClassName}
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            {children}
          </div>
        </ClickAwayListener>
      </div>
    </div>
  );
};

export default ModalContainer;
